import {Component, input, InputSignal} from '@angular/core';

@Component({
  selector: 'icon-list',
  imports: [],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" [attr.width]="size()" [attr.height]="size()"
         viewBox="0 0 24 24">
      <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
            d="M16.5 19.8571V21m0-1.1429c-1.0122 0-1.9039-.505-2.427-1.2719m2.427 1.2719c1.0122 0 1.9039-.505
            2.427-1.2719M16.5 14.1429c1.0123 0 1.9041.5051 2.4271 1.2721M16.5 14.1429c-1.0123 0-1.9041.5051-2.4271
            1.2721M16.5 14.1429V13m3.5 1.7143-1.0729.7007m-5.9267 3.8707 1.0726-.7005M13 14.7143l1.0729.7007m5.9267
            3.8707-1.0726-.7005m.0001-3.1702c.3093.4535.4896.9986.4896 1.585 0 .5864-.1804 1.1316-.4897
            1.5852m-4.8541-3.1702c-.3093.4535-.4896.9986-.4896 1.585 0 .5864.1804 1.1316.4897 1.5852M4 3h16M4 9h16M4 15h5" />
    </svg>
  `
})
export class IconListComponent {
  size: InputSignal<number> = input<number>(24);
}
